// extracted by mini-css-extract-plugin
module.exports = {"MuiTableCellRoot":"TableCell_MuiTableCellRoot__onSCb","MuiTableCellRootHeader":"TableCell_MuiTableCellRootHeader__2qViI"};